class MFRStoreLocatorEmbed {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            destiniLocator: "#destini-locator",
            postalCodeInput: "[name='searchZip']",
            submitButton: "button[aria-label='Search']"
        }
        
        if( !this.$element.length ) return;
        this.init();
    }

    init() {
        this.checkForEmbed().then( () => {
            this.$shadowRoot = $( this.$element.find( this.selectors.destiniLocator ).get(0).shadowRoot );
            this.$postalCodeInput = this.$shadowRoot.find( this.selectors.postalCodeInput );
            this.$submitButton = this.$shadowRoot.find( this.selectors.submitButton );
            console.log( this.$shadowRoot.find( '[name="searchZip"]') );

            const urlParams = new URLSearchParams( window.location.search );
            const zipCodeParam = urlParams.get('zip_code');
            if( typeof zipCodeParam === "string" ) this.updateShadowRootForm( zipCodeParam );
        } );
    }

    checkForEmbed() {
        return new Promise( ( resolve, reject ) => {
            const interval = setInterval( () => {
                if( $( this.$element.find( this.selectors.destiniLocator ).get( 0 ).shadowRoot ).find( "chakra-scope" ).length ) {
                    clearInterval( interval );
                    resolve();
                }
            }, 1 );
        } );
    }

    updateShadowRootForm( zipCode ) {
        console.log( this.$postalCodeInput, this.$submitButton );
        this.$postalCodeInput.val( zipCode );
        this.$submitButton.click();
    }
}